import 'mutationobserver-shim';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';

import Vue from 'vue';

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueSmoothScroll from 'vue2-smooth-scroll';
import LoadScript from 'vue-plugin-load-script';
import i18n from './i18n';
import { config } from '@/helpers/firebaseConfig';
import App from './App.vue';
import router from './router';
import store from './store';

import { intercomeWidgetInit } from './plugins/intercome';

intercomeWidgetInit();

firebase.initializeApp(config);
firebase.analytics();

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
};

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(
    record => record.meta.requiresAuth === true
  );
  const shouldBeLoggedOut = to.matched.some(
    record => record.meta.shouldBeLoggedOut === true
  );
  const isLoggedIn = (await firebase.getCurrentUser()) != null;
  store.commit('updateUserLoggedIn', isLoggedIn);

  if (requiresAuth && !isLoggedIn) {
    next({ name: 'Login' });
  } else if (shouldBeLoggedOut && isLoggedIn) {
    next({ name: 'UserDetails' });
  } else {
    next();
  }
});

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(LoadScript);
Vue.use(VueSmoothScroll, {
  updateHistory: false
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
